import React, { useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../../../../store/hooks'
import { selectAccountId } from '../../../../../../store/auth/authSlice'
import { useLazyListAiAgentResultQuery } from '../../../../../../store/ai/aiAgentResult'
import { AIAgentType } from '../../../../../../models/AIAgent'
import { usePollingEffect } from '../../../common/hooks/usePollingEffect'
import { selectFormIsPolling, addFormAiAgentResults } from '../../../../../../store/meetingSummary/forms'

export interface FormPollerProps {
  aiFeatureId: string
}

export const FormPoller: React.FC<FormPollerProps> = ({ aiFeatureId }) => {
  const { roomId = '', sessionId = '' } = useParams()
  const accountId = useAppSelector(selectAccountId)

  usePollForm(accountId, roomId, sessionId, aiFeatureId)

  return null
}

const usePollForm = (accountId: string, roomId: string, sessionId: string, aiFeatureId: string) => {
  const dispatch = useAppDispatch()

  const formIsPolling = useAppSelector((state) => selectFormIsPolling(state, aiFeatureId))

  const [triggerListAiAgentResults] = useLazyListAiAgentResultQuery()

  const getFormResults = useCallback(async () => {
    const formResults = await triggerListAiAgentResults(
      {
        accountId,
        type: AIAgentType.FORM,
        resultKey: `${roomId}|${sessionId}|${aiFeatureId}`,
        partialKeyMatch: true,
      },
      false,
    ).unwrap()
    if (formResults.length) {
      dispatch(addFormAiAgentResults(formResults))
    }
  }, [dispatch, accountId, roomId, sessionId, aiFeatureId, triggerListAiAgentResults])

  const { start: startFormPolling, stop: stopFormPolling } = usePollingEffect(getFormResults, [], {
    interval: 3000,
  })

  useEffect(() => {
    if (formIsPolling) {
      startFormPolling()
    } else {
      stopFormPolling()
    }
  }, [formIsPolling, startFormPolling, stopFormPolling])
}
